module.exports = __webpack_public_path__ + "static/img/logo.ffc9b245.svg";